import React from "react";
import { CreditCard, Landmark } from "lucide-react";

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
    <path d="M16.37 12.6c-.02-2.2 1.8-3.26 1.88-3.31-1.03-1.5-2.62-1.7-3.18-1.73-1.35-.14-2.64.8-3.33.8-.69 0-1.74-.78-2.87-.76-1.47.02-2.83.86-3.59 2.18-1.53 2.66-.39 6.6 1.1 8.76.73 1.06 1.6 2.24 2.73 2.2 1.1-.04 1.51-.71 2.84-.71 1.32 0 1.7.71 2.86.69 1.18-.02 1.93-1.07 2.65-2.13.84-1.22 1.18-2.41 1.2-2.47-.03-.01-2.3-.88-2.3-3.5zM14.2 6.13c.6-.73 1.01-1.75.9-2.76-.87.04-1.92.58-2.54 1.31-.56.64-1.05 1.68-.92 2.67.97.08 1.96-.49 2.56-1.22z" />
  </svg>
);

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15A11 11 0 0 0 2.18 7.06L5.84 9.9C6.71 7.3 9.14 5.38 12 5.38z" />
  </svg>
);

const methods = [
  { label: "Card", icon: <CreditCard className="w-4 h-4" /> },
  { label: "Apple Pay", icon: <AppleIcon /> },
  { label: "Google Pay", icon: <GoogleIcon /> },
  { label: "Link", icon: <span className="w-4 h-4 rounded-full bg-[#00D66F] text-black text-[10px] font-bold flex items-center justify-center">L</span> },
  { label: "ACH", icon: <Landmark className="w-4 h-4" /> },
];

export default function PaymentMethods() {
  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">
        Payments are processed through Stripe.com and can be completed with the following payment methods.
      </p>
      <div className="flex flex-wrap gap-2">
        {methods.map((m) => (
          <span key={m.label} className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border border-border text-xs font-medium">
            {m.icon}
            {m.label}
          </span>
        ))}
      </div>
    </div>
  );
}